import getScenarioStore from '../store/getScenarioStore';
import { SearchScenarioId } from 'owa-search-next-common';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'updateSelectedPillIndex',
    (scenarioId: SearchScenarioId, selectedPillIndex: number) => {
        getScenarioStore(scenarioId).selectedPillIndex = selectedPillIndex;
    }
);
